export { default, default as Heading } from './Heading'
export { default as headingTheme } from './themes/Heading.theme'
export * as HeadingStyles from './styles/Heading.style'

export type { HeadingProps, BaseHeadingProps } from './Heading.types'
export type { AppearanceKeys, HeadingTheme } from './themes/Heading.theme.types'
export type { StyledHeadingProps } from './styles/Heading.style.types'
